import {eventBus} from "../../service/eventBus";
import React from 'react';
import {ErrorMessageContent} from '../../components/style-guide/modal/components/ErrorMessage/ErrorMessageContent';
import {ModalHelper} from "../../shared/modal";
import {InfoMessageContent} from "../../components/style-guide/modal/components/InfoMessage/InfoMessageContent";
import {navigate} from '@reach/router';
import {Api, AppRouters} from "../../settings";
import http from "../../service/api";

export const syncWithLocalStorage = (fetch = true) => {
    return (dispatch) => {
        dispatch({type: 'SYNC_WITH_LOCAL_STORAGE'})
    }
};

export const reduxEventBusDispatcher = (event, payload) => {
    return (dispatch) => {
        dispatch({type: 'EVENT_BUS_ACTION', payload: {event, payload}});
        eventBus.dispatch(event, payload);
    }
};

export const handleRoutingError = (error, reportId = '') => {
    return (dispatch) => {
        switch (error) {
            case 'EXPIRED_PAYMENT': {
                return navigate(AppRouters.myReports, {replace: true}).then(() => {
                    ModalHelper.open('',
                        <InfoMessageContent
                            title="¡Solicitud Cancelada!"
                            message="Ha expirado la solicitud, por favor cree una nueva."
                            onAcceptAction={() => ModalHelper.close()}/>,
                        null,
                        {className: 'empty-modal-title'}
                    );
                });
            }

            case 'INCOMPLETE_PAYMENT': {
                return navigate(AppRouters.myReports, {replace: true}).then(() => {
                    ModalHelper.open('', <ErrorMessageContent
                        message="Realice nuevamente la solicitud. Si el error persiste contáctenos"/>, null, {className: 'empty-modal-title'});
                });
            }

            case 'payment-denied': {
                return navigate(AppRouters.myReports, {replace: true}).then(() => {
                    ModalHelper.open('',
                        <InfoMessageContent
                            title="¡Solicitud cancelada!"
                            message="La solicitud no será procesada porque el pago no fue efectuado."
                            onAcceptAction={() => ModalHelper.close()}/>,
                        null,
                        {className: 'empty-modal-title'}
                    );

                    dispatch(deniedPaymentAction(reportId));
                });
            }

            case 'payment-canceled': {
                return navigate(AppRouters.myReports, {replace: true}).then(() => {
                    ModalHelper.open('', <InfoMessageContent
                            onAcceptAction={() => ModalHelper.close()}
                            title="¡Solicitud cancelada!"
                            message="La solicitud no será procesada porque el pago fue cancelado."/>,
                        null,
                        {className: 'empty-modal-title'});
                });
            }

            default:
                return null;
        }
    }
};

export const deniedPaymentAction = (reportId) => {
    return async (dispatch) => {
        await http.get(Api.deniedRequest(reportId));
    };
}
